import React from "react";
import PropTypes from "prop-types";
//Material Imports
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
//Limitless Imports
import { useNotificationContext } from "@limitless/common/hooks/notification/NotificationContext";
import CustomerButton from "../customer-button/CustomerButton";
import { useTranslation } from "@limitless/common/hooks/translation/TranslationContext";
const useStyles = makeStyles(theme => ({
  toastContainer: {
    background: theme.palette.contrast.main,
    display: "flex",
    animation: "$llmToastFadeIn 0.5s ease-in both",
    justifyContent: "space-between",
    position: "absolute",
    width: "100%",
    zIndex: 2
  },
  "@media screen and (max-width: 450px)": {
    toastContainer: {
      top: 56
    }
  },
  "@keyframes llmToastFadeIn": {
    from: {
      opacity: "0"
    },
    to: {
      opacity: "1"
    }
  },
  textColor: {
    color: theme.palette.contrast.light
  },
  text: {
    lineHeight: 1,
    paddingLeft: 24,
    paddingTop: 0,
    paddingBottom: 0,
    paddingRight: 0,
    display: "flex",
    alignItems: "center"
  }
}));
const Toast = ({
  headerSize
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const {
    notification,
    clearNotification
  } = useNotificationContext();
  const {
    t
  } = useTranslation();
  const handleDismiss = () => {
    clearNotification();
  };
  React.useEffect(() => {
    let autoDismissTimer;
    if (notification.title) {
      autoDismissTimer = setTimeout(clearNotification, 200000);
    }
    return () => {
      clearTimeout(autoDismissTimer);
    };
  }, [notification.title]);
  if (!notification.title) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classes.toastContainer,
    style: {
      top: headerSize
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    classes: {
      root: `${classes.text} ${classes.textColor}`
    }
  }, t(notification.title)), /*#__PURE__*/React.createElement(CustomerButton, {
    onClick: handleDismiss,
    variant: "text",
    style: {
      color: theme.palette.contrast.light
    }
  }, "Dismiss"));
};
export default Toast;
Toast.propTypes = {
  headerSize: PropTypes.number
};
Toast.defaultProps = {
  headerSize: 63
};